import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'antd';
import './RDSwitch.scss';

const RDSwitch = ({
  size,
  checked,
  defaultChecked,
  checkedChildren,
  unCheckedChildren,
  onChange,
  disabled,
  switchStyle,
}) => (
  <Switch
    size={size}
    checked={checked}
    defaultChecked={defaultChecked}
    checkedChildren={checkedChildren}
    unCheckedChildren={unCheckedChildren}
    onChange={onChange}
    disabled={disabled}
    style={switchStyle}
  />
);

RDSwitch.defaultProps = {
  size: 'large',
  checked: false,
  defaultChecked: false,
  checkedChildren: '',
  unCheckedChildren: '',
  disabled: false,
  switchStyle: {},
  onChange: () => {},
};

RDSwitch.propTypes = {
  /** The size of the Switch, options: default small */
  size: PropTypes.string,
  /** Determine whether the Switch is checked */
  checked: PropTypes.bool,
  /** Whether to set the initial state */
  defaultChecked: PropTypes.bool,
  /** The content to be shown when the state is checked */
  checkedChildren: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** The content to be shown when the state is unchecked */
  unCheckedChildren: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Trigger when the checked state is changing */
  onChange: PropTypes.func,
  /** Disable switch */
  disabled: PropTypes.bool,
  /** Switch Style */
  switchStyle: PropTypes.shape({}),
};

export default RDSwitch;
